import React from "react";
import { formatTotal } from "../../../../../../utils/generalFormat";
import { ValueCard } from "../../../../billingPanel/components/totals/styles";
import { TotalsDataHistory } from "../../types";
import useGetMe from "../../../../../../hooks/useCurrentUser";

export const Totals: React.FC<{ data: TotalsDataHistory }> = ({ data }) => {
  const user = useGetMe();

  return (
    <>
      <div style={{ display: "flex", justifyItems: "left" }}>
        <ValueCard>
          <div style={{ height: "100px", width: "220px" }}>
            <p style={{ fontWeight: "bolder" }}>Valor Líquido Original:</p>
            <p>{formatTotal(data.totalLiquid)}</p>
          </div>

          <div style={{ height: "100px", width: "220px" }}>
            <p style={{ fontWeight: "bolder" }}>Novo Valor Líquido:</p>
            <p>{formatTotal(data.totalNewLiquid)}</p>
          </div>

          {(user.userType === 3) && (
            <div style={{ height: "100px", width: "220px" }}>
              <p style={{ fontWeight: "bolder" }}>
                Receita Antecipação Pontual:
              </p>
              <p>{formatTotal(data.totalRevenue)}</p>
            </div>
          )}
        </ValueCard>
      </div>
    </>
  );
};
